/**
 * TitleScreen.tsx
 *
 * BETA 22.50 — the start menu is now the front-facing Sorry Boss StartMenu
 * (dark gunmetal nav + live character-cycling hero), replacing the old
 * classroom / chalkboard-warp menu.
 */
import { motion } from 'framer-motion';
import StartMenu from './StartMenu';

interface Props {
  onStartGame: (charIdx: number) => void;
  onSettings?: () => void;
  onQuests?: () => void;
  onUnlocks?: () => void;
  onLoadout?: () => void;
  onSignOut?: () => void;   // present only when signed in — StartMenu shows SIGN OUT in the Discord/News row
  signedIn?: boolean;
  onRequestSignIn?: (charIdx?: number) => void;  // START RUN while signed out raises the auth overlay
  username?: string;
  inputLocked?: boolean;
}

export default function TitleScreen({ onStartGame, onSettings, onQuests, onLoadout, onSignOut, signedIn, onRequestSignIn, username, inputLocked }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      style={{ position: 'fixed', inset: 0 }}
    >
      <StartMenu onStartGame={onStartGame} username={username} onOpenSettings={onSettings} onOpenLoadout={onLoadout} onOpenQuests={onQuests} onSignOut={onSignOut} signedIn={signedIn} onRequestSignIn={onRequestSignIn} inputLocked={inputLocked} />
    </motion.div>
  );
}
